import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

/**
 * A parent page controller for the operator sub-states mainly used for configuring the primary toolbar and navigational tabs display
 */
export class OperatorPageController {
  public static $inject = [
    'operator',
    'ACTToolbarService',
    '$state',
    '$translate'
  ];

  constructor(
    public operator: InterACT.Interfaces.TransportOperators.TransportOperator,
    private toolbarService: ACTToolbarService,
    private $state: ng.ui.IStateService,
    private $translate: ng.translate.ITranslateService
  ) {
    this.activate();
  }

  /**
   * Configures the primary toolbar title and navigation breadbcrumbs.
   */
  private activate() {
    const currentLocale = this.$translate.use();
    this.toolbarService.getToolbar('primary').then((toolbar: any) => {
      toolbar.setTitle(this.operator.name[currentLocale]);
      toolbar.setTabs([
        {
          label: 'SUMMARY',
          sref: 'operator.summary'
        },
        {
          label: 'REGISTRATIONS',
          sref: 'operator.services'
        }
      ], this.$state.current.data.selectedTab);
    });
  }
}